import React from 'react'

const ModifySearchCross = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="c-pointer"
        >
            <path
                d="M12 4L8 8M8 8L4 12M8 8L4 4M8 8L12 12"
                stroke="#212121"
                stroke-width="1.2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    )
}

export default ModifySearchCross
